<section id="fhc">
    <div class="container-fluid">
        <div class="panel panel-default">
            <div class="panel-heading">
                <h3 class="panel-title">First Hydro</h3>
            </div>
            <div class="panel-body">
                <div class="row">
                    <div class="col-md-6" [style]="'margin-top: 10px; vertical-align: bottom;'">Last refresh:
                        {{FHCLastRefresh }} </div>
                    <div class="col-md-6" [style]="'padding: 16px; text-align: right;'"
                        [style.background]="'transparent'">
                        <nj-button size="normal" type="button" [isDisabled]="false" icon="" [hasCustomIcon]="false"
                            (buttonClick)="GetFHCInstructions()">
                            Refresh
                        </nj-button>
                    </div>
                </div>

                <div><b>Instructions</b></div>
                <app-fhc-instructions [GridData]="FHCInstructionsData"
                    (OnViewInstruction)="OnViewAssetInstruction(Assets.FirstHydro, $event, false)"></app-fhc-instructions>
                <div><b>Ad Hoc Instructions</b></div>
                <app-adhoc-instructions [GridData]="FHCAdHocData" [Asset]="Assets.FirstHydro"
                    (OnViewInstruction)="OnViewAssetInstruction(Assets.FirstHydro, $event, true)"></app-adhoc-instructions>
            </div>
        </div>
    </div>
</section>
<section id="moweo">
    <div class="container-fluid">
        <div class="panel panel-default">
            <div class="panel-heading">
                <h3 class="panel-title">Moray East</h3>
            </div>
            <div class="panel-body">
                <div class="row">
                    <div class="col-md-6" [style]="'margin-top: 10px; vertical-align: bottom;'">Last refresh:
                        {{MorayEastLastRefresh }} </div>
                    <div class="col-md-6" [style]="'padding: 16px; text-align: right;'"
                        [style.background]="'transparent'">
                        <nj-button size="normal" type="button" [isDisabled]="false" icon="" [hasCustomIcon]="false"
                            (buttonClick)="GetMorayEastInstructions()">
                            Refresh
                        </nj-button>
                    </div>
                </div>

                <div><b>Instructions</b></div>
                <div class="scroll-container">
                    <app-moray-east-instructions [GridData]="MorayEastInstructionsData"
                        (OnViewInstruction)="OnViewAssetInstruction(Assets.MorayEast, $event, false)"></app-moray-east-instructions>
                </div>
                <div><b>Ad Hoc Instructions</b></div>
                <div class="scroll-container">
                    <app-adhoc-instructions [GridData]="MorayEastAdHocData" [Asset]="Assets.MorayEast"
                        (OnViewInstruction)="OnViewAssetInstruction(Assets.MorayEast, $event, true)"></app-adhoc-instructions>

                </div>
            </div>
        </div>
    </div>
</section>
<section id="mowwl">
    <div class="container-fluid">
        <div class="panel panel-default">
            <div class="panel-heading">
                <h3 class="panel-title">Moray West</h3>
            </div>
            <div class="panel-body" id="mowwlPanel">
                <div class="row">
                    <div class="col-md-6" [style]="'margin-top: 10px; vertical-align: bottom;'">Last refresh:
                        {{MorayWestLastRefresh }} </div>
                    <div class="col-md-6" [style]="'padding: 16px; text-align: right;'"
                        [style.background]="'transparent'">
                        <nj-button size="normal" type="button" [isDisabled]="false" icon="" [hasCustomIcon]="false"
                            (buttonClick)="GetMorayWestInstructions()">
                            Refresh
                        </nj-button>
                    </div>
                </div>

                <div><b>Instructions</b></div>
                <app-moray-west-instructions [GridData]="MorayWestInstructionsData"
                    (OnViewInstruction)="OnViewAssetInstruction(Assets.MorayWest, $event, false)"></app-moray-west-instructions>
                <div><b>Ad Hoc Instructions</b></div>
                <app-adhoc-instructions [GridData]="MorayWestAdHocData" [Asset]="Assets.MorayWest"
                    (OnViewInstruction)="OnViewAssetInstruction(Assets.MorayWest, $event, true)"></app-adhoc-instructions>
            </div>
        </div>
    </div>
</section>
<section id="retail">
    <div class="container-fluid">
        <div class="panel panel-default">
            <div class="panel-heading">
                <h3 class="panel-title">Retail</h3>
            </div>
            <div class="panel-body">
                <div class="row">
                    <div class="col-md-6" [style]="'margin-top: 10px; vertical-align: bottom;'">Last refresh:
                        {{RetailLastRefresh }} </div>
                    <div class="col-md-6" [style]="'padding: 16px; text-align: right;'"
                        [style.background]="'transparent'">
                        <nj-button size="normal" type="button" [isDisabled]="false" icon="" [hasCustomIcon]="false"
                            (buttonClick)="GetRetailInstructions()">
                            Refresh
                        </nj-button>
                    </div>
                </div>

                <div><b>Instructions</b></div>
                <app-adhoc-instructions [GridData]="RetailAdHocData" [Asset]="Assets.Retail"
                    (OnViewInstruction)="OnViewAssetInstruction(Assets.Retail, $event, false)"></app-adhoc-instructions>
            </div>
        </div>
    </div>
</section>
<section id="res">
    <div class="container-fluid">
        <div class="panel panel-default">
            <div class="panel-heading">
                <h3 class="panel-title">RES</h3>
            </div>
            <div class="panel-body" id="mowwlPanel">
                <div class="row">
                    <div class="col-md-6" [style]="'margin-top: 10px; vertical-align: bottom;'">Last refresh:
                        {{ResLastRefresh }} </div>
                    <div class="col-md-6" [style]="'padding: 16px; text-align: right;'"
                        [style.background]="'transparent'">
                        <nj-button size="normal" type="button" [isDisabled]="false" icon="" [hasCustomIcon]="false"
                            (buttonClick)="GetResInstructions()">
                            Refresh
                        </nj-button>
                    </div>
                </div>

                <div><b>Instructions</b></div>
                <app-res-instructions [GridData]="ResInstructionsData"
                    (OnViewInstruction)="OnViewAssetInstruction(Assets.Res, $event, false)"></app-res-instructions>
                <div><b>Ad Hoc Instructions</b></div>
                <app-adhoc-instructions [GridData]="ResAdHocData" [Asset]="Assets.Res"
                    (OnViewInstruction)="OnViewAssetInstruction(Assets.Res, $event, true)"></app-adhoc-instructions>
            </div>
        </div>
    </div>
</section>
